import React from 'react';

import { withRouter } from 'react-router-dom';
import AccountService from '../../../Service/AccountService';

import { Button } from 'antd';
import CashoutDetails from './CashoutDetails';

import Table from '../../Common/Table';
import { convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

class Cashout extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_showModal: false,
			_cashoutid: null
		};
	}

	setCashoutSource = async queryUrl => {
		return AccountService.getRecordCashout(this.props.match.params.id, queryUrl);
	};

	handleShowModal = id => {
		this.setState({ _showModal: !this.state._showModal, _cashoutid: id });
	};

	render() {
		const dayjs = require('dayjs');
		const cashout = [
			{
				name: 'cashout_date',
				label: 'Date/Time',
				options: {
					sort: false,
					customBodyRender: value => {
						return value ? convertToPhilippinesTime(value) : 'N/A';
					}
				}
			},
			{
				name: 'channel',
				label: 'Channel',
				options: {
					sort: false,
					customBodyRender: value => {
						return value || 'LendAmi Wallet';
					}
				}
			},
			{
				name: 'total_amount',
				label: 'Amount(₱)',
				options: {
					sort: false,
					customBodyRender: value => {
						const PHP = new Intl.NumberFormat('PH', {
							style: 'currency',
							currency: 'PHP'
						});
						return PHP.format(Number(value).toFixed(2));
					}
				}
			},
			{
				name: 'id',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<Button onClick={() => this.handleShowModal(value)} type="link">
								Detail
							</Button>
						);
					}
				}
			}
		];
		return (
			<>
				<CashoutDetails
					cancel={() => this.setState({ _showModal: false })}
					id={this.state._cashoutid}
					open={this.state._showModal}
				/>

				<Table
					columns={cashout}
					dataSourceHandler={this.setCashoutSource}
					dataSourceName="wallet"
					title="Wallet Cash-outs"
				/>
			</>
		);
	}
}

export default withRouter(hot(module)(Cashout));
